<template>
  <!-- rankings -->
  <div>
    <button class="button-icon square-icon w3-right" href="#/" title="calculate ranking" v-if="managementFunctions" @click="calculateRanking()"><font-awesome-icon icon="wrench" /></button>
    <h2>{{ $t('tournaments.standings') }} {{activeRoundNumber}}</h2>

    <div v-for="group in tournament.groups"
          :key="group.groupId"
          :group="group">
      <div v-if="tournament.groups.length > 1"><font-awesome-icon icon="users" class=""/> {{group.name}}</div>
      <div v-if="groupRankings(group.groupId).length == 0 ">Nog aan te vullen</div>
      <div v-if="rankings.length > 0">
        <table class="result-table"><tbody>
          <tr class="result-header">
            <td class="tdSpace">#</td>                         
            <td>{{ $t('tournaments.name') }}</td>                         
            <td class="visibleIfSpaceAvailable">{{ $t('tournaments.score') }}</td>                         
            <td class="visibleIfSpaceAvailable" :title="$t('tournaments.valueTitle')">{{ $t('tournaments.value') }}</td>                         
            <td :title="$t('tournaments.pointsTitle')">{{ $t('tournaments.points') }}</td>                         
            <td class="visibleIfSpaceAvailable center" :title="$t('tournaments.wonTitle')">{{ $t('tournaments.won') }}</td>                         
            <td class="visibleIfSpaceAvailable center" :title="$t('tournaments.drawTitle')">{{ $t('tournaments.draw') }}</td>                         
            <td class="visibleIfSpaceAvailable center columnspace" :title="$t('tournaments.lostTitle')">{{ $t('tournaments.lost') }}</td>                         
            <td class="visibleIfSpaceAvailable" :title="$t('tournaments.bTitle')">{{ $t('tournaments.B') }}</td>                         
            <td class="visibleIfSpaceAvailable" :title="$t('tournaments.wTitle')">{{ $t('tournaments.W') }}</td>                         
            <td class="visibleIfSpaceAvailable" :title="$t('tournaments.sbTitle')">{{ $t('tournaments.sb') }}</td>                         
            <td class="visibleIfSpaceAvailable" :title="$t('tournaments.tprTitle')">{{ $t('tournaments.tpr') }}</td>                         
          </tr>

          <tr class="result-row" v-for="ranking in groupRankings(group.groupId)"
                                    :key="ranking.rankingId" 
                                    :ranking="ranking">
            <td class="tdSpace">{{ranking.rank}}</td>                         
            <td>{{ranking.participant.person.name}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.score}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.value}}</td>                         
            <td>{{ranking.points}}</td>                         
            <td class="visibleIfSpaceAvailable center">{{ranking.won}}</td>                         
            <td class="visibleIfSpaceAvailable center">{{ranking.draw}}</td>                         
            <td class="visibleIfSpaceAvailable center columnspace" >{{ranking.lost}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.nrBlack}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.nrWhite}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.sb}}</td>                         
            <td class="visibleIfSpaceAvailable">{{ranking.tpr}}</td>                         
          </tr>
        </tbody></table>
      </div>  
    </div>    
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
const apiName = 'api';

export default {
  name: 'ResultRankingKeizer',
  components: {},
  props: {
    rankings: { type: Array, required: false, default: () => [{ rankingId: 0, name: "No rannkings provided" }] },
    tournament: Object,
    activeRoundNumber: Number,
    managementFunctions: Boolean,
    roundId: Number
  },
  methods: {
    calculateRanking() {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      let path = "/Ranking/calculate?roundId=" + this.roundId;
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          console.log('Rankings calculated.' + response);
        })
        .catch(error => {
          var message = error.response.data.message;
          this.modalText = '<b>fout bij het bepalen van de stand.</b> <br/> ' + message;
          this.showingModal=true;
        });
    },

    groupRankings: function(groupId) {
      return this.rankings.filter(m => m.groupId == groupId);
    }
  }
}
</script>

<style scoped>

  .center {
    text-align: center;
  }

  .columnspace {
    padding-right: 16px;
  }

  .groupSection {
    margin: 0vw 2vw;   
  }
  
  .imgbtn {
    text-decoration: none;
    float: right;
    border: 1px solid #333333;
    border-radius: 2px;
    margin-left: 4px;
  }

  .pageSection {
    margin-bottom: 2vw;
  }

  select {
    border-radius: 2px;
  }

  .tdSpace {
    margin: 0 2px;
  }

/* mobile */
@media screen and (max-width: 600px) {

  .visibleIfSpaceAvailable {
    display: none;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {

  .visibleIfSpaceAvailable {
    display: table-cell;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .visibleIfSpaceAvailable {
    display: table-cell;
  }
}

</style>
